"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlogPlatform = exports.isSocialPlatform = exports.getBlogPlatforms = exports.getSocialPlatforms = exports.Platforms = exports.PlatformType = exports.platformSource = exports.PlatformEnum = exports.Platform = void 0;
/**
 * @deprecated Use PlatformEnum
 */
var Platform;
(function (Platform) {
    Platform["FACEBOOK"] = "facebook";
    Platform["INSTAGRAM"] = "instagram";
    Platform["THREADS"] = "threads";
    Platform["LINKEDIN"] = "linkedin";
    Platform["WORDPRESS"] = "wordpress";
    Platform["CUSTOM_BLOG"] = "custom-blog";
    Platform["GOOGLE_BUSINESS"] = "google-business";
    Platform["YOUTUBE"] = "youtube";
    Platform["TIKTOK"] = "tiktok";
    Platform["X"] = "x";
})(Platform || (exports.Platform = Platform = {}));
exports.PlatformEnum = {
    FACEBOOK: "facebook",
    INSTAGRAM: "instagram",
    THREADS: "threads",
    LINKEDIN: "linkedin",
    WORDPRESS: "wordpress",
    CUSTOM_BLOG: "custom-blog",
    GOOGLE_BUSINESS: "google-business",
    YOUTUBE: "youtube",
    TIKTOK: "tiktok",
    X: "x",
};
exports.platformSource = Object.values(Platform);
var PlatformType;
(function (PlatformType) {
    PlatformType["SOCIAL"] = "social";
    PlatformType["BLOG"] = "blog";
})(PlatformType || (exports.PlatformType = PlatformType = {}));
exports.Platforms = {
    [exports.PlatformEnum.FACEBOOK]: {
        id: exports.PlatformEnum.FACEBOOK,
        type: PlatformType.SOCIAL,
        constraints: {
            message: {
                min: 80,
                max: 63206,
            },
            media: {
                min: 0,
                max: 25,
            },
        },
    },
    [exports.PlatformEnum.INSTAGRAM]: {
        id: exports.PlatformEnum.INSTAGRAM,
        type: PlatformType.SOCIAL,
        constraints: {
            message: {
                min: 80,
                max: 2200,
            },
            media: {
                min: 1,
                max: 20,
            },
        },
    },
    [exports.PlatformEnum.THREADS]: {
        id: exports.PlatformEnum.THREADS,
        type: PlatformType.SOCIAL,
        constraints: {
            message: {
                min: 80,
                max: 500,
            },
            media: {
                min: 0,
                max: 20,
            },
        },
    },
    [exports.PlatformEnum.LINKEDIN]: {
        id: exports.PlatformEnum.LINKEDIN,
        type: PlatformType.SOCIAL,
        constraints: {
            message: {
                min: 80,
                max: 3000,
            },
            media: {
                min: 0,
                max: 9,
            },
        },
    },
    [exports.PlatformEnum.WORDPRESS]: {
        id: exports.PlatformEnum.WORDPRESS,
        type: PlatformType.BLOG,
        constraints: {
            title: {
                min: 80,
                max: 300,
            },
            content: {
                min: 80,
                max: 1000000,
            },
            media: {
                min: 0,
                max: 1,
            },
        },
    },
    [exports.PlatformEnum.CUSTOM_BLOG]: {
        id: exports.PlatformEnum.CUSTOM_BLOG,
        type: PlatformType.BLOG,
        constraints: {
            title: {
                min: 80,
                max: 300,
            },
            content: {
                min: 80,
                max: 1000000,
            },
            media: {
                min: 0,
                max: 1,
            },
        },
    },
    [exports.PlatformEnum.GOOGLE_BUSINESS]: {
        id: exports.PlatformEnum.GOOGLE_BUSINESS,
        type: PlatformType.SOCIAL,
        constraints: {
            message: {
                min: 80,
                max: 1500,
            },
            media: {
                min: 0,
                max: 1,
            },
        },
    },
    [exports.PlatformEnum.YOUTUBE]: {
        id: exports.PlatformEnum.YOUTUBE,
        type: PlatformType.SOCIAL,
        constraints: {
            message: {
                min: 0,
                max: 5000,
            },
            media: {
                min: 1,
                max: 1,
            },
        },
    },
    [exports.PlatformEnum.TIKTOK]: {
        id: exports.PlatformEnum.TIKTOK,
        type: PlatformType.SOCIAL,
        constraints: {
            message: {
                min: 0,
                max: 2200,
            },
            media: {
                min: 1,
                // 1 video or up to 35 photos (carousel); mixing is rejected in validateTikTokMedia
                max: 35,
            },
        },
    },
    [exports.PlatformEnum.X]: {
        id: exports.PlatformEnum.X,
        type: PlatformType.SOCIAL,
        constraints: {
            message: {
                min: 1,
                max: 280,
            },
            media: {
                // v1: one image or one video only; multi-image is out of scope
                min: 0,
                max: 1,
            },
        },
    },
};
// Function to get all social platforms with proper typing
const getSocialPlatforms = () => {
    return Object.entries(exports.Platforms)
        .filter(([_key, platform]) => platform.type === PlatformType.SOCIAL)
        .map(([key]) => key);
};
exports.getSocialPlatforms = getSocialPlatforms;
// Function to get all blog platforms with proper typing
const getBlogPlatforms = () => {
    return Object.entries(exports.Platforms)
        .filter(([_key, platform]) => platform.type === PlatformType.BLOG)
        .map(([key]) => key);
};
exports.getBlogPlatforms = getBlogPlatforms;
// Type guard to check if a platform is social
const isSocialPlatform = (platform) => {
    return exports.Platforms[platform].type === PlatformType.SOCIAL;
};
exports.isSocialPlatform = isSocialPlatform;
// Type guard to check if a platform is blog
const isBlogPlatform = (platform) => {
    return exports.Platforms[platform].type === PlatformType.BLOG;
};
exports.isBlogPlatform = isBlogPlatform;
